<template>
	<div>
		<div class="overallBackground">
			<!-- 	<div class="wholes">
				<img src="../assets/image/loginBackground.png" alt="" />
			</div> -->
			<div class="loginBox">
				<div class="signIn">
					<img src="../assets/image/loginBackgrounds.png" alt="" />
				</div>
				<div class="loginContent">
					<div class="mainImage">
						<img src="../assets/image/mainImage.png" alt="" />
					</div>
					<div class="welcome">
						<img src="../assets/image/welcome.png" alt="" />
					</div>
					<div class="inputBox">
						<input type="text" placeholder="请输入手机号" maxlength="11" v-model="phone" />
					</div>
					<div class="inputBox">
						<input type="text" placeholder="请输入验证码" v-model="code">
						<div class="verificationCode" @click="getCode()">
							{{codeBtnWord}}
						</div>
					</div>
					<div class="register" @click='jumpTo("/register")'>快速注册</div>
					<div class="signInbutt" @click="onSubmit()">登录</div>
					<div class="agreement">
						<img src="../assets/icon/unchecked.png" alt="" v-if="doYouWantToChoose==false"
							@click="switchSelection" />
						<img src="../assets/icon/choice.png" alt="" v-else @click="switchSelection" />
						<div>我已阅读并同意<span @click='jumpTo("/agreement",1)'>《用户服务协议》</span>与<span
								@click='jumpTo("/agreement",2)'>《隐私政策》</span></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		sendCode,
		smsLogin
	} from "@/api/api.js"
	export default {
		data() {
			return {
				doYouWantToChoose: false,
				phone: '',
				code: '',
				codeBtnWord: '获取验证码', // 获取验证码按钮文字
				waitTime: 60, // 获取验证码按钮失效时间
				getCodeBtnDisable: false,
			}
		},

		methods: {
			getCode() {
				if (this.phone == '') {
					this.$message.error('请输入手机号');
					return
				}
				let reg = /^1[3456789]\d{9}$/
				if (!reg.test(this.phone)) {
					this.$message.error('手机号格式不正确');
					return
				}
				if (this.getCodeBtnDisable == false) {
					sendCode({
						phone: this.phone
					}).then(res => {
						if (res.code == 200) {
							this.$message.success('验证码发送成功')
							let that = this
							that.waitTime--
							that.getCodeBtnDisable = true
							this.codeBtnWord = `${this.waitTime}s 后重新发送`
							let timer = setInterval(function() {
								if (that.waitTime > 1) {
									that.waitTime--
									that.codeBtnWord = `${that.waitTime}s 后重新发送`
								} else {
									clearInterval(timer)
									that.codeBtnWord = '获取验证码'
									that.getCodeBtnDisable = false
									that.waitTime = 60
								}
							}, 1000)
						} else {
							this.$message.error(res.msg);
							return
						}
					})

				} else {
					this.$message.error('请勿重复点击');
				}



			},
			onSubmit() {
				if (this.phone == '') {
					this.$message.error('请输入手机号');
					return
				}
				if (this.code == '') {
					this.$message.error('请输入验证码');
					return
				}
				if (this.doYouWantToChoose == false) {
					this.$message.error('请阅读并勾选《用户服务协议》与《隐私政策》');
					return
				}
				smsLogin({
					phone: this.phone,
					code: this.code,
				}).then(res => {
					if (res.code == 200) {
						this.$message({
							message: res.msg,
							type: 'success'
						});
						localStorage.setItem('token', res.data.token)
						setTimeout(() => {
							this.$router.push({
								path: '/index/home'
							})
						}, 1000);
					} else {
						this.$message.error(res.msg);
					}
					console.log(res, '2222222');
				})
			},
			switchSelection() {
				this.doYouWantToChoose = !this.doYouWantToChoose
			},
			jumpTo(url, i) {
				this.$router.push({
					path: url,
					query: {
						type: i
					}
				}).catch(() => {})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.overallBackground {
		width: 100%;
		height: 100vh;
		background-image: url('../assets/image/loginBackground.png');
		background-size: cover;
		/* 或者其他你需要的大小设置 */
		background-position: center;
		/* 背景图片居中 */
		background-repeat: no-repeat;
		/* 背景图片不重复 */
		cursor: default;


		.loginBox {
			position: relative;
			top: 100px;
			left: 55%;
			right: 0;
			width: 613px;
			height: 681px;

			.signIn {
				width: 613px;
				height: 681px;

				img {
					width: 613px;
					height: 681px;
				}
			}

			.loginContent {
				position: absolute;
				top: 40px;
				left: 93px;
				right: 93px;

				.mainImage {
					width: 150px;
					height: 67.35px;
					margin: 0 auto;

					img {
						width: 150px;
						height: 67.35px;
					}
				}

				.welcome {
					width: 100%;
					height: 40px;
					margin: 43px auto;

					img {
						width: 100%;
						height: 40px;
					}
				}

				.inputBox {
					display: flex;
					align-items: center;
					justify-content: space-between;
					padding: 14px 30px;
					background: #FFFFFF;
					border-radius: 4px 4px 4px 4px;
					margin-bottom: 30px;

					input {
						border: none;
						outline: none;
						box-shadow: none;
						flex: 1;
						font-family: PingFang SC, PingFang SC;
						font-weight: bold;
						font-size: 20px;
						color: #333333;

					}

					.verificationCode {
						flex: 1;
						font-family: PingFang SC, PingFang SC;
						font-weight: 500;
						font-size: 16px;
						color: #DF632B;
					}
				}

				.register {
					font-family: PingFang SC, PingFang SC;
					font-weight: 500;
					font-size: 16px;
					color: #999999;
					text-align: right;
					cursor: default;
				}

				.signInbutt {
					margin-top: 59px;
					height: 50px;
					background: linear-gradient(90deg, #ECBF85 0%, #D89A3A 100%);
					border-radius: 30px 30px 30px 30px;
					font-family: PingFang SC, PingFang SC;
					font-weight: bold;
					font-size: 20px;
					color: #FFFFFF;
					text-align: center;
					line-height: 50px;
				}

				.agreement {
					display: flex;
					align-items: center;
					margin-top: 42px;
					margin-left: 30px;

					img {
						width: 16px;
						height: 16px;
					}

					div {
						margin-left: 8px;
						font-family: PingFang SC, PingFang SC;
						font-weight: 500;
						font-size: 14px;
						color: #777777;

						span {
							color: #663300;
						}
					}
				}
			}

		}
	}
</style>